export default class Answers {
    constructor() {
        this.answers = JSON.parse(localStorage.answers || '{}');
    }

    all() {
        return this.answers;
    }

    get(questionId) {
        return this.answers[questionId] || null;
    }

    set(questionId, answer) {
        this.answers[questionId] = answer;
        localStorage.answers = JSON.stringify(this.answers);
    }

    removeAll() {
        localStorage.removeItem('answers');
    }
}